import { render, staticRenderFns } from "./BaseThumbnail.vue?vue&type=template&id=4b4bfda6&scoped=true&"
import script from "./BaseThumbnail.vue?vue&type=script&lang=js&"
export * from "./BaseThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./BaseThumbnail.vue?vue&type=style&index=0&id=4b4bfda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4bfda6",
  null
  
)

export default component.exports